import React from "react";
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import SyncIcon from "@mui/icons-material/Sync";
import { Star } from "@mui/icons-material";
import { clearTemplatesFilters, refreshTemplates } from "actions/templatesActions";
import { clearFilesFilters, handleFavoriteDownload, refreshFiles } from "actions/filesActions";
import { clearRegionalsFilters, refreshRegionals } from "actions/regionalsActions";
import { boxStyle, iconButtonStyle, iconButtonSubmit } from "pages/DashboardHelpers";
import { clearBtpsFilters, getBtpStatus, refreshBtps, triggerBtp } from "actions/btpAction";
import { clearDashboardFilters, refreshDashboard } from "actions/dashboardActions";
import { snackBar } from "actions/modelActions";
import { clearOcplcDashboardFilters, refreshOcplc } from "actions/ocplcAction";
import UploadDownloadDataTransIcons from "./OcplcEditDashboard/OcplcWorkSpaceButtons/UploadDownloadDatatransIcons";
import ParametersAndLocalizationButtons from "./OcplcEditDashboard/OcplcWorkSpaceButtons/parametersAndLocalizationButtons";

const actionMapping = {
  "Templates": { clear: clearTemplatesFilters, refresh: refreshTemplates },
  "PCX Files": { clear: clearFilesFilters, refresh: refreshFiles, download: handleFavoriteDownload },
  "Regionals": { clear: clearRegionalsFilters, refresh: refreshRegionals },
  "BTP": { clear: clearBtpsFilters, refresh: refreshBtps },
  "Environment to Refresh": { refresh: getBtpStatus, submit: triggerBtp },
  "New Models and Models with Updates": { clear: clearDashboardFilters, refresh: refreshDashboard },
  "OCPLC Dashboard": { clear: clearOcplcDashboardFilters, refresh: refreshOcplc }
};

export default function ActionButtons({ title, setCheckedDashboardRows, handleNavRefresh, Api, tableData, checkedDashboardRows, userRole, userEmail, checkedRows, setSelectedIds, selectedIds }) {
  const { filteredProducts } = useSelector(state => state.files.models && state.files);
  const getBTPStatus = useSelector((state) => state.btps.getBTPStatus);
  const disableSubmit = getBTPStatus?.isRunning || !checkedRows?.length;
  const disableDownload = !filteredProducts?.some(product => product.isFavorite);
  const dispatch = useDispatch();

  const actions = actionMapping[title];

  const handleRefresh = () => {
    dispatch(actions.refresh(Api));
    dispatch(snackBar(true, "Refresh successfully", 'success'));
  }

  const handleDownload = () => {
    dispatch(actions.download());
  }

  const handleClearFilters = () => {
    if (title === "OCPLC Dashboard") {
        setCheckedDashboardRows([]);
        setSelectedIds([]);
    } else if (title === "BTP") {
        setCheckedDashboardRows([]);
    }
    dispatch(actions.clear());
  }

  const handleSubmit = () => {
    dispatch(actions.submit(checkedRows, Api));
  }

  const hasSelectedRows = checkedDashboardRows?.length > 0;

  return (
    <Box sx={boxStyle}>
      <Typography variant="h5" style={{ marginTop: '13px' }}>{title}</Typography>
      <div style={{ display: "flex" }}>

        {title === "OCPLC Dashboard" && (
          <>
          <ParametersAndLocalizationButtons
            tableData={tableData} 
            dashboardrole={userRole}
            userEmail={userEmail}
          />
           <UploadDownloadDataTransIcons 
             title={title} 
             tableData={tableData} 
             disabled={!hasSelectedRows}
             dashboardrole={userRole}
             userEmail={userEmail}
             checkedRows={checkedDashboardRows} 
             setCheckedRows={setCheckedDashboardRows}
             setSelectedIds={setSelectedIds}
             selectedIds={selectedIds}
           />
          </>
        )}
        {actions?.download && (
          <Button color="primary" disableRipple onClick={handleDownload} sx={iconButtonStyle} disabled={disableDownload} endIcon = {<Star style={{ color: "#FFBF00" }} />}>
            Download
          </Button>
        )}
        {!actions?.submit && (
          title === "OCPLC Dashboard" ? (
            <Tooltip title="Clear Filters">
              <IconButton color="primary" onClick={handleClearFilters} sx={iconButtonStyle}>
                <FilterAltOffIcon />
              </IconButton>
            </Tooltip>
          ) : (
            <Button color="primary" disableRipple onClick={handleClearFilters} sx={iconButtonStyle} endIcon={<FilterAltOffIcon />}>
              Clear Filters
            </Button>
          )
        )}
        {title === "OCPLC Dashboard" ? (
          <Tooltip title="Refresh">
            <IconButton color="primary" onClick={handleRefresh} sx={iconButtonStyle}>
              <SyncIcon />
            </IconButton>
          </Tooltip>
        ) : (
          <Button color="primary" disableRipple onClick={handleRefresh} sx={iconButtonStyle} endIcon={<SyncIcon />}>
            Refresh
          </Button>
        )}
        {actions?.submit && (
          <Button variant="contained" size="large" disableRipple onClick={handleSubmit} sx={iconButtonSubmit} disabled={disableSubmit}>
            Submit
          </Button>
        )}
      </div>
    </Box>
  );
}